/* ============================================================
 * TMT Accordion — DEPRECATED.
 *
 * Accordions now use native <details>/<summary>, so no JS is needed.
 * This file is intentionally a no-op so existing <script> tags that
 * still reference it don't 404. It also exports a TMTAccordion shim
 * so older callers don't throw.
 * ============================================================ */
(function () {
  'use strict';
  if (window.__tmtAccordionLoaded) return;
  window.__tmtAccordionLoaded = true;
  window.TMTAccordion = {
    init: function () {},
    initOne: function () {}
  };
})();
